import { ArrowDownTrayIcon, CheckIcon } from "@heroicons/react/20/solid";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import {
  Square3Stack3DIcon,
  UserCircleIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/solid";
import React from "react";
import MsingiPoaTabs from "./MsingiPoaTabs";
import { FiArrowDownCircle } from 'react-icons/fi'
import CriticalApply from '../../assets/CriticalApply.pdf'
import CriticalClaim from '../../assets/CriticalClaim.pdf'

export default function ElimuSmart() {
  return (
    <div className="text-ternary-dark dark:text-ternary-light  ">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto mt-16 max-w-xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
            <h3 className="text-4xl font-bold tracking-tight">
              Elimu Smart Education Plan
            </h3>
            <p className="mt-6 text-base max-w-l leading-7 ">
              Elimu Smart is a new school fees insurance solution which
              guarantees that your child's school fees continues to be paid in
              their current school should an unfortunate event occur leaving you
              unable to provide for them.{" "}
            </p>
            <p className="mt-6 text-base max-w-l leading-7">
              It is flexible, affordable and fully available online without the
              need to visit any physical branch or present physical documents.
              Elimu Smart covers the following eventualities;
            </p>
            <p className="mt-6 text-base max-w-l leading-7">
              The unfortunate event of a parents death from natural causes or as
              a result of an accident.
            </p>

            <p className="mt-6 text-base max-w-l leading-7">
              A parent is diagnosed with a critical illness such as cancer,
              stroke, heart disease etc.{" "}
            </p>

            <p className="mt-6 text-base max-w-l leading-7">
              In the case of total and permanent disability as a result of
              injury or illness which leaves the parent unable to work and
              provide for their family.
            </p>

            <p className="mt-6 text-base max-w-l leading-7">
              This cover is renewable every year and the premium you pay is
              calculated based on your child's current school fees. You also
              have the flexibility to select the number of years you would want
              the school fees covered for.
            </p>

            <p className="mt-6 text-base max-w-l leading-7">
              Elimu Smart is brought to you through a Britam and Bismart
              partnership.
            </p>

            <div className="mt-10 flex items-center gap-x-4">
            <div className="flex gap-x-4 items-center  ">
              <a
                download={CriticalApply}
                href={CriticalApply}
                className="font-general-medium flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-indigo-50 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 text-gray-500 hover:text-white duration-500"
                aria-label="Download Resume"
              >
                <FiArrowDownCircle className="mr-2 sm:mr-3 h-5 w-5 sn:w-6 sm:h-6 duration-100"></FiArrowDownCircle>
                <span className="text-sm sm:text-lg font-general-medium duration-100">
                  Application Form
                </span>
              </a>
              <a
                href={CriticalClaim}
                download={CriticalClaim}
                className="font-general-medium flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-indigo-50 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 text-gray-500 hover:text-white duration-500"
                aria-label="Download Resume"
              >
                <FiArrowDownCircle className="mr-2 sm:mr-3 h-5 w-5 sn:w-6 sm:h-6 duration-100"></FiArrowDownCircle>
                <span className="text-sm sm:text-lg font-general-medium duration-100">
                  Claim Form
                </span>
              </a>
           
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
